import styled from 'styled-components';

export const RecordsUpdateStyle = styled.div`
  padding: 30px;
  text-align: center;

  div {
    display: block;
    justify-content: center;
    align-items: center;

    img {
      background-color: ${({ theme }) => theme.palette.success.main};
      fill: ${({ theme }) => theme.palette.common.white};
      padding: 16px;
      border-radius: 50%;
      width: 74px;
      height: 74px;
      box-sizing: border-box;
    }
    h2 {
      color: ${({ theme }) => theme.palette.primary.main};
    }
    p {
      color: ${({ theme }) => theme.palette.text.secondary};
    }
    button {
      margin: 5px 0;
    }
  }
`;
